// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".fade-enter-active,\n\t.fade-leave-active {\n  transition: all 0.6s;\n}\n.fade-enter,\n\t.fade-leave-to {\n  opacity: 0;\n}\n", ""]);
// Exports
module.exports = exports;
